import { useApiPut } from '@/api/main/query'
import { useToast } from '@/shared/hooks'
import { useQueryClient } from '@tanstack/react-query'
import { deviceAPI } from '../api/endpoints'
import { DeviceModel, NewNameDeviceModel } from '../types/types'

export const useUpdateDeviceName = (deviceId: string, onSuccessCallback?: () => void) => {
  const { addToast } = useToast()
  const queryClient = useQueryClient()

  const { mutate: updateName } = useApiPut<DeviceModel, NewNameDeviceModel>(deviceAPI.updateName, {
    onSuccess: (value) => {
      addToast('Успех!', 'Наименование устройства обновлено', 'success')
      console.log('Успешный ответ:', value)
      queryClient.invalidateQueries({ queryKey: ['device', deviceId] })
      queryClient.invalidateQueries({ queryKey: ['devices'] })
      if (onSuccessCallback) onSuccessCallback()
    },
    onError: (error) => {
      addToast('Ошибка!', error.message, 'error')
    },
  })

  const handleUpdateName = (data: NewNameDeviceModel) => {
    updateName(data)
  }

  return { handleUpdateName }
}
